module.exports = __webpack_public_path__ + "img/DOT51EHV.6fd6a9c0.png";